import { render, staticRenderFns } from "./StartupEdit.vue?vue&type=template&id=5801cd99&scoped=true"
import script from "./StartupEdit.vue?vue&type=script&lang=js"
export * from "./StartupEdit.vue?vue&type=script&lang=js"
import style0 from "./StartupEdit.vue?vue&type=style&index=0&id=5801cd99&prod&scoped=true&lang=css"
import style1 from "./StartupEdit.vue?vue&type=style&index=1&id=5801cd99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801cd99",
  null
  
)

export default component.exports